const GestorIcon = ({ color = "currentColor", size = 24 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 158 158"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
    >
      <g transform="translate(0,158) scale(0.1,-0.1)">
        <path d="M661 1294 c-237 -64 -413 -291 -410 -529 2 -138 -13 -149 269 191 140 170 263 318 273 331 l18 23 -48 -1 c-26 0 -72 -7 -102 -15z"/>
        <path d="M695 894 c-357 -297 -435 -366 -377 -335 19 10 862 550 870 557 7 6 -33 52 -68 76 l-35 25 -390 -323z"/>
        <path d="M823 673 c-266 -108 -480 -199 -478 -203 5 -8 33 -1 638 161 l347 93 0 57 c0 58 -7 89 -19 89 -3 -1 -223 -89 -488 -197z"/>
        <path d="M780 419 c-184 -15 -342 -28 -350 -29 -23 -1 57 -68 122 -101 188 -95 398 -72 576 64 29 22 62 53 73 69 l20 28 -53 -1 c-29 -1 -204 -14 -388 -30z"/>
      </g>
    </svg>
  );
  
  export default GestorIcon;
  